import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from './adapter-registry';
import _ from 'lodash';
import { A365Named, NamedAdapter } from 'shell-models-lib';
import { notImplementedFunction } from 'app/extension/api/common';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(A365Named),
    adapts: {
        name: '*',
        properties: {
            description: '*'
        }
    }
})
/**
 * TODO: Temporary Adapter to get global search working. Once we fully transition to the specific
 * Named classes (Notebook, SqlScript, etc.), this adapter may be removed.
 */
export class A365SubResourceAdapter extends NamedAdapter<A365Named, {}> {
    protected _toResource(named: A365Named): {} {
        return super._toResource(named);
    }

    protected _toModel(resource: {}, named?: A365Named): A365Named {
        // Not used.
        return notImplementedFunction();
    }
}
